import * as React from 'react';
import { X } from 'lucide-react';
import { cn } from '@/lib/utils';

export interface FilterChip {
  key: string;
  /** Текст чипа: «Регистрация: 01.10 – 31.10.2026». */
  label: React.ReactNode;
  onRemove: () => void;
  /** aria-label крестика; по умолчанию «Убрать фильтр: <label>». */
  removeLabel?: string;
}

export interface FilterChipsProps {
  chips: FilterChip[];
  /** «Сбросить» — показывается, если есть хотя бы один чип. */
  onReset?: () => void;
  resetLabel?: string;
  className?: string;
}

/** Активные фильтры списка + «Сбросить» (макет «Пользователи»). Ничего не рендерит без чипов. */
export function FilterChips({ chips, onReset, resetLabel = 'Сбросить', className }: FilterChipsProps) {
  if (chips.length === 0) return null;
  return (
    <div className={cn('flex flex-wrap items-center gap-2', className)}>
      <ul aria-label="Активные фильтры" className="m-0 flex list-none flex-wrap gap-2 p-0">
        {chips.map((chip) => (
          <li key={chip.key}>
            <span className="inline-flex h-[30px] items-center gap-1.5 rounded-full bg-muted pl-3 pr-1.5 text-[13px] font-semibold text-text">
              {chip.label}
              <button
                type="button"
                onClick={chip.onRemove}
                aria-label={chip.removeLabel ?? `Убрать фильтр: ${typeof chip.label === 'string' ? chip.label : chip.key}`}
                className="grid size-[22px] place-items-center rounded-full text-text-2 outline-none hover:bg-surface hover:text-text focus-visible:ring-2 focus-visible:ring-ring"
              >
                <X className="size-3.5" strokeWidth={2.2} aria-hidden />
              </button>
            </span>
          </li>
        ))}
      </ul>
      {onReset && (
        <button
          type="button"
          onClick={onReset}
          className="h-[30px] rounded-lg px-2 text-sm font-semibold text-accent-text outline-none hover:underline focus-visible:ring-2 focus-visible:ring-ring"
        >
          {resetLabel}
        </button>
      )}
    </div>
  );
}
